import { createVNode as l, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FemaleFilledStandard.js";
import m from "../components/PfIcon.js";
const e = (r, t) => {
  const a = {
    ...r,
    ...t.attrs
  };
  return l(m, o(a, {
    icon: d
  }), null);
};
e.displayName = "FemaleFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
